/* Publish by EComposer at 2026-10-31 21:01:59*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ae6qrjexcub"]=  window.__ectimmers["ecom-ae6qrjexcub"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ae6qrjexcub').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ae6qrjexcub', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u1i11fyy1th').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u1i11fyy1th', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c4l7nlt5d1b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c4l7nlt5d1b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2vewwqrhdhd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2vewwqrhdhd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vhsqjmbq5v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vhsqjmbq5v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yok6buci30e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yok6buci30e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-to0e6aby1lg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-to0e6aby1lg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jpu3jkdawf8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jpu3jkdawf8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a73i2tzq3k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a73i2tzq3k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ik7sex2gt1b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ik7sex2gt1b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0ziziha9cxq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0ziziha9cxq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l4n1r7c3wm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l4n1r7c3wm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sl6zg1r9nti').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sl6zg1r9nti', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ie999d3qswq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ie999d3qswq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4e1qszm44p8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4e1qszm44p8', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2hr8xjb42tr"]=  window.__ectimmers["ecom-2hr8xjb42tr"] || {};
let t=this.$el;if(!t)return;let e=t.querySelectorAll(":scope > .tabs__wrapper > div > .tabs__navs > .tabs__navs--items > .tabs__nav"),i=t.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),s=this.settings.action;function o(a,l){a.classList.contains("ecom-item-active")||(e.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),i[l].classList.add("ecom-item-active"),setTimeout(()=>{const c=i[l];c&&c.querySelectorAll(".ec_splide").forEach(d=>{var p;(p=d.ec_splide)==null||p.refresh()})},50),r())}e.forEach((a,l)=>{s==="click"||window.screen.width<1025?a.onclick=()=>o(a,l):a.onmouseover=()=>o(a,l)});function n(){let a=window.location.hash;if(a){let l=t.querySelector(`[data-target="${a}"]`);if(l){l.click();let c=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});l.dispatchEvent(c);let m=l.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,m)}}}setTimeout(()=>{n()},300);function r(){setTimeout(()=>{const a=t.querySelector(".tab__item.ecom-item-active");a&&a.querySelectorAll(".ec_splide").forEach(l=>{var c;(c=l.ec_splide)==null||c.refresh()}),window.dispatchEvent(new window.Event("resize"))},100)}window.addEventListener("hashchange",n,!1)

                    });
                    
                        document.querySelectorAll('.ecom-2hr8xjb42tr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2hr8xjb42tr', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nwdsl71ib2b"]=  window.__ectimmers["ecom-nwdsl71ib2b"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-nwdsl71ib2b"]["8nal9g3ix"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-nwdsl71ib2b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nwdsl71ib2b', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a5sqo2vonuq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a5sqo2vonuq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4une7if4p3w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4une7if4p3w', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qfk7to782u8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qfk7to782u8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}